export default [
  {
    title: "图库",
    name: "",
    canShu: "",
  },
  {
    title: "书架",
    name: "BookList",
    canShu: "",
  },
  {
    title: "个人作品",
    name: "MyDrawing",
    canShu: "",
  },
  {
    title: "店铺",
    name: "Shop",
    canShu: "",
  },
  {
    title: "关于",
    name: "About",
    canShu: "",
  },
];
